/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskLayoffsEntry } from './ExecRiskLayoffsEntry';
import {
    ExecRiskLayoffsEntryFromJSON,
    ExecRiskLayoffsEntryFromJSONTyped,
    ExecRiskLayoffsEntryToJSON,
} from './ExecRiskLayoffsEntry';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedLayoffsResponse
 */
export interface ExecRiskPaginatedLayoffsResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedLayoffsResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskLayoffsEntry>}
     * @memberof ExecRiskPaginatedLayoffsResponse
     */
    results: Array<ExecRiskLayoffsEntry>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedLayoffsResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedLayoffsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedLayoffsResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedLayoffsResponse interface.
 */
export function instanceOfExecRiskPaginatedLayoffsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedLayoffsResponseFromJSON(json: any): ExecRiskPaginatedLayoffsResponse {
    return ExecRiskPaginatedLayoffsResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedLayoffsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedLayoffsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskLayoffsEntryFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedLayoffsResponseToJSON(value?: ExecRiskPaginatedLayoffsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskLayoffsEntryToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

